
<div>
<div class="position-relative" usbScrollToTopDirective [showAfter]="100">
  <button *ngIf="splashFinish" type="button" class="btn-home px-2 bg-white" (click)="navigateHome()"><i class="bi bi-house-door-fill mr-1"></i>IR AL INICIO</button>



<ng-container *ngIf="loadedVisual">

  <!-- Header tipo hero (inspirado en https://vista-editorial-gallery.lovable.app/#): usa la
       imagen/título/descripción que manda destination-big/destination-small al navegar acá
       (ver articleRedirect() en esos componentes). Si no vinimos desde ahí (ej. desde
       "artículos relacionados") no hay datos y este header no se muestra.
       Slider: combina la portada (headerFromOrigin.image) con las fotos de la galería propia
       del artículo (ver buildHeroImages() en el component) para que se note el efecto de
       crossfade, no una sola imagen fija. -->
  <header class="article-hero" *ngIf="headerFromOrigin">
    <div class="article-hero_frame">
      <div class="article-hero_slider">
        <img *ngFor="let img of heroImages; let i = index; trackBy: trackByHeroImage"
             [src]="img"
             [alt]="headerFromOrigin.title"
             class="article-hero_img"
             [class.article-hero_img--active]="i === heroActiveIndex">
      </div>
      <div class="article-hero_scrim"></div>

      <div class="article-hero_overlay">
        <div class="article-hero_grid">
          <div class="article-hero_title-col">
            <h1 class="article-hero_title" style="margin-right: 25px">{{ headerFromOrigin.title }}</h1>
          </div>
          <div class="article-hero_desc-col">
            <p class="article-hero_description">{{ headerFromOrigin.description }}</p>
          </div>
        </div>

        <div class="article-hero_footer">
          <button type="button" class="article-hero_cue" (click)="scrollToArticleStart()">
            <span class="article-hero_cue-icon"><i class="bi bi-arrow-down"></i></span>
            <span class="article-hero_cue-text">Seguí leyendo</span>
          </button>

          <div class="article-hero_dots" *ngIf="heroImages.length > 1">
            <button type="button"
                    *ngFor="let img of heroImages; let i = index; trackBy: trackByHeroImage"
                    class="article-hero_dot"
                    [class.article-hero_dot--active]="i === heroActiveIndex"
                    [attr.aria-label]="'Ver imagen ' + (i + 1)"
                    (click)="goToHeroImage(i)">
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- Apartado "artículos" en formato acordeón desplegable (inspirado en
       https://vista-editorial-gallery.lovable.app/#): se listan TODOS los items de
       title[0].info / text (antes solo se mostraba el que coincidía con activeArticle).
       Sin numeración cuando hay un solo item. La columna de la derecha ("Datos útiles" en la
       referencia) se deja vacía por ahora, reservando el espacio para una futura incorporación. -->
  <section class="article-accordion-section" id="article-start" *ngIf="article.length > 0">
    <div class="article-accordion-layout">
      <div class="article-accordion-list">
        <article class="article-accordion-item" [id]="'article-accordion-item-' + i" *ngFor="let text of article[0].title[0]?.info; let i = index">
          <div class="article-accordion-item_row">
            <span class="article-accordion-item_number" *ngIf="hasMultipleSections()">{{ padSectionNumber(i) }}</span>
            <div class="article-accordion-item_body">
              <h3 class="article-accordion-item_title">{{ text?.title }}</h3>
              <p class="article-accordion-item_preview">{{ text?.description }}</p>
              <div class="article-accordion-item_collapse" [class.article-accordion-item_collapse--open]="isTextExpanded(i)">
                <div class="article-accordion-item_collapse-inner">
                  <div class="article-main_content article-accordion-item_content" [innerHTML]="article[0].text[i]"></div>
                </div>
              </div>
              <button type="button"
                      *ngIf="isAccordionEnabled()"
                      class="article-accordion-item_toggle"
                      [attr.aria-expanded]="isTextExpanded(i)"
                      (click)="toggleTextSection(i)">
                <span class="article-accordion-item_toggle-icon" [class.article-accordion-item_toggle-icon--open]="isTextExpanded(i)">

                  <i class="bi bi-arrow-down" style='margin-left: 2px;'></i>
                </span>
                {{ isTextExpanded(i) ? 'Ver menos' : 'Ver más' }}
              </button>
            </div>
          </div>
        </article>
      </div>

      <!-- Datos útiles: mockup fijo por título (ver USEFUL_DATA_ENTRIES en el component) hasta
           que el back lo traiga armado. Solo se muestra para los títulos que tienen entrada ahí. -->
      <aside class="article-accordion-aside">
        <div class="d-flex flex-column align-items-center" *ngIf="usefulData.length > 0">
          <div class="mb-2" style="border-bottom: 1px solid #cecfd1">
            <p class="title mb-0">Datos útiles</p>
          </div>

          <div class="d-flex justify-content-between py-3 align-items-center px-4"
               style="width:85%; border-bottom: 1px solid #cecfd1; gap: 20px;"
               *ngFor="let data of usefulData; trackBy: trackByUsefulData">
              <div class="d-flex flex-column" style="width: 65px">
                <p class="value-imp-description" style="text-align: end">{{ data.value }}</p>
                <p class="value-nom-description" style="text-align: end">{{ data.unit }}</p>
              </div>
              <i class="bi bi-arrow-right" [ngStyle]="{'color': getClientsSettingAppAuth?.clients_setting_global?.color_main_1}"></i>
              <div style="width: 60%;">
                <p class="text-description-aside">
                  {{ data.description }}
                </p>
              </div>
          </div>


        </div>

        <div class="mt-1" style="margin-left: 2em;">
             <p class="footer-information">* Datos orientativos de {{getfooterInformationLocation(headerFromOrigin?.title)}}</p>
          </div>
      </aside>

    </div>
  </section>

  <!-- Formato anterior. Se deja comentado hasta confirmar que el acordeón nuevo quedó bien. -->
  <!--
  <article class="article-main" *ngIf="article.length > 0">
    <ng-container *ngFor="let text of article[0].title[0]?.info; let i = index">
      <ng-container *ngIf="activeArticle === i">
        <h1 class="article-main_title">{{text?.title}}</h1>
      </ng-container>
    </ng-container>
      <div class="article-main_body" *ngIf="article && article.length > 0">
        <ng-container *ngFor="let text of article[0].title[0]?.info; let i = index">
          <ng-container *ngIf="activeArticle === i">
            <h2 class="article-main_copy" style="text-align: center; font-size: 22px !important"><b>{{text.description}}</b>
            </h2>
          </ng-container>
        </ng-container>
        <br>
        <ng-container *ngFor="let text of article[0].text; let i = index">
          <ng-container *ngIf="activeArticle === i">
            <ng-container *ngIf="typeArticle === 'small'">
              <div class="article-main_content" [innerHTML]="text"></div>
            </ng-container>
            <ng-container *ngIf="typeArticle === 'big'">
              <div class="article-main_content" [innerHTML]="text"></div>
            </ng-container>
            <ng-container *ngIf="typeArticle === 'segment'">
              <div class="article-main_content" [innerHTML]="text"></div>
            </ng-container>
            <ng-container *ngIf="typeArticle === 'aboutUs'">
              <div class="article-main_content" [innerHTML]="text"></div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
  </article>
  -->

<!-- Articulos destacados del home -->


  <section *ngIf="images && images.length > 0" class="container-fluid" style="margin-top: 70px;">
    <h1 class="section-article_title">Galería de imágenes</h1>
    <!-- <div class="article-galery">
      <img src="./assets/img/articles/articles-galery.jpg">
    </div> -->

    <!-- Galería anterior (carousel de a 1 imagen con paginación). Se deja comentada hasta
         confirmar que el mosaico nuevo quedó bien. -->
    <!--
    <div class="d-flex flex-column justify-content-center" >

        <div *ngFor="let image of images | paginate: { itemsPerPage: 1, currentPage: p }; let i = index"
              >
          <img src="{{routeUploadFile + image}}" class="img-fluid" alt="img" loading="lazy" (load)="loadImagenGalery()">

        <div class="d-flex justify-content-end" style="margin-top: 22px">
          <pagination-controls previousLabel=""
          nextLabel="" maxSize="5" (pageChange)="p = $event"></pagination-controls>
        </div>
      </div>
    </div>
    -->

    <!-- Galería en mosaico (inspirada en https://editorial-gallery-view.lovable.app/): masonry
         por columnas CSS con un patrón fijo de proporciones por foto (no depende de la relación
         de aspecto real de cada imagen, que en la práctica viene casi pareja) para garantizar que
         se vea irregular, zoom + velo oscuro con texto al pasar el mouse, y lightbox al click. -->
    <div class="mosaic-gallery">
      <button type="button"
              class="mosaic-tile"
              *ngFor="let image of images; let i = index"
              (click)="openLightbox(i)"
              [attr.aria-label]="'Ver foto ' + (i + 1) + ' en grande'">
        <img [src]="routeUploadFile + image"
             class="mosaic-tile_img"
             alt="Foto {{ i + 1 }} de la galería"
             loading="lazy"
             (load)="loadImagenGalery()">
        <span class="mosaic-tile_overlay">
          <span class="mosaic-tile_text">Foto {{ i + 1 }}</span>
        </span>
      </button>
    </div>

  </section>

  <!-- Lightbox de la galería en mosaico -->
  <div class="mosaic-lightbox"
       *ngIf="lightboxOpen"
       role="dialog"
       aria-modal="true"
       [attr.aria-label]="'Foto ' + (lightboxIndex + 1)"
       (click)="closeLightbox()">
    <button type="button" class="mosaic-lightbox_close" (click)="closeLightbox($event)" aria-label="Cerrar">
      <i class="bi bi-x-lg"></i>
    </button>
    <button type="button" *ngIf="images.length > 1" class="mosaic-lightbox_nav mosaic-lightbox_nav--prev" (click)="lightboxPrev($event)" aria-label="Anterior">
      <i class="bi bi-chevron-left"></i>
    </button>
    <button type="button" *ngIf="images.length > 1" class="mosaic-lightbox_nav mosaic-lightbox_nav--next" (click)="lightboxNext($event)" aria-label="Siguiente">
      <i class="bi bi-chevron-right"></i>
    </button>
    <figure class="mosaic-lightbox_figure" (click)="$event.stopPropagation()">
      <img [src]="routeUploadFile + images[lightboxIndex]" class="mosaic-lightbox_img" alt="Foto {{ lightboxIndex + 1 }} de la galería">
      <figcaption class="mosaic-lightbox_caption">Foto {{ lightboxIndex + 1 }} de {{ images.length }}</figcaption>
    </figure>
  </div>

  <!---------------------------------------  RELACIONADOS  --------------------------------------------->
  <!-- Nuevo estilo (inspirado en https://vista-editorial-gallery.lovable.app/#). La data ya no sale
       de article[0].relationated: son 3 destinos elegidos semi-azarosamente de destination-big/small
       (ver buildRelatedDestinations() en el component), para invitar a seguir navegando el sitio. -->
  <ng-container *ngIf="relatedDestinations.length > 0">
    <section class="related-articles-card">
      <div class="d-flex align-items-center mb-5" style="gap: 10px;">
        <p class="mb-0" style="font-family: 'Lato'; color:#838cb6;font-size: 11px;text-wrap: nowrap;letter-spacing: 1px;">SEGUÍ LEYENDO</p>
        <div style="background-color:#cecfd1;height: 1px; width: 100%"></div>
      </div>
      <div class="related-articles-header">
        <h2 class="related-articles-title">Artículos relacionados</h2>
      </div>

      <ul class="related-articles-grid">
        <li class="related-articles-item" *ngFor="let destination of relatedDestinations">
          <a href="javascript:void(0)" class="related-articles-link" (click)="goToRelatedDestination(destination)">
            <div class="related-articles-media">
              <img [src]="destination.image" loading="lazy" alt="{{destination.title}}" class="related-articles-img">
            </div>
            <div class="container-arrow-relationated">
                  <i class="bi bi-arrow-up-right related-articles-arrow" style="margin-right: 2px;font-size: 13px"></i>
            </div>

            <p class="related-articles-eyebrow">Recomendaciones</p>
            <h3 class="related-articles-item-title">
              <span>{{ destination.title }}</span>
            </h3>
            <p class="related-articles-copy">{{ destination.description }}</p>
          </a>
        </li>
      </ul>
    </section>
  </ng-container>

  <!-- Estilo anterior. Se deja comentado hasta confirmar que el nuevo quedó bien. -->
  <!--
  <ng-container *ngIf="article && article.length > 0 && article[0].relationated.length > 0 && article[0].relationated[0]?.info && article[0].relationated[0]?.info.length > 0">
  <section class="section-related">
    <p class="section-article_title">artículos relacionados</p>

  <div class="d-flex">


      <ng-container *ngFor="let relation of article[0].relationated[0]?.info; let i = index; let last = last">
        <ng-container *ngIf="activeArticle !== i">
          <div class="article-related-grid">
            <div class="article-card " [ngClass]="{'card-black': isSecondVisibleElement(i)}">
            <figure class="article-card_figure">
              <img src="{{routeUploadFile + relation.image}}" loading="lazy" alt="{{relation.title}}">
            </figure>
            <div class="article-card_body ">
              <div class="d-flex flex-column" id="style-card-text">
                <h3 class="article-card_subtitle">
                  Recomendaciones
                </h3>
                <h2 class="article-card_title" style="letter-spacing: 0px; line-height: 1em;">
                  {{relation.title}}
                </h2>
                <p class="article-card_copy">
                  {{relation.subtitle}}
                </p>
                <button class="article-relation" (click)="showArticle(i)"
                  [ngStyle]="{'background-color':getClientsSettingAppAuth?.clients_setting_global?.color_main_3}"
                  style="margin-bottom:15px;">ver</button>
              </div>
            </div>
          </div>
          </div>
          </ng-container>
        </ng-container>
      </div>
    </section>
  </ng-container>
  -->
</ng-container>
</div>
</div>
